import axios from 'axios';
import {
  ForgotPasswordData,
  ResendVerificationEmailData,
  ResetPasswordData,
  SignUpData,
  VerifyEmailData,
} from '~/types';

export const signUpApi = async (data: SignUpData): Promise<SignUpData> => {
  try {
    const res = await axios.post('/api/auth/signup', data);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const resetPasswordApi = async (data: ResetPasswordData) => {
  try {
    const res = await axios.post('/api/auth/reset-password', data);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const forgotPasswordApi = async (data: ForgotPasswordData) => {
  try {
    const res = await axios.post('/api/auth/forgot-password', data);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const verifyEmailApi = async (data: VerifyEmailData) => {
  try {
    const res = await axios.post('/api/auth/verify-email', data);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const resendVerificationEmailApi = async (
  data: ResendVerificationEmailData,
) => {
  try {
    const res = await axios.post('/api/auth/resend-verification', data);
    return res.data;
  } catch (error) {
    throw error;
  }
};
